// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/ratfink/ratfink.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "ratfink 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "ratfink 1.aseprite": {
      frame: {
        x: 16,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "ratfink 2.aseprite": {
      frame: {
        x: 32,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "ratfink 3.aseprite": {
      frame: {
        x: 48,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "ratfink.png",
    format: "RGBA8888",
    size: {
      w: 64,
      h: 16,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    anim: [
      "ratfink 0.aseprite",
      "ratfink 1.aseprite",
      "ratfink 2.aseprite",
      "ratfink 3.aseprite",
    ],
  },
};
export const ratfink = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const anim = new AnimatedSprite(spritesheet.animations.anim);

  anim.width = 32;
  anim.height = 32;
  anim.anchor.set(0.5, 0.5);

  return anim;
};
